import { render, staticRenderFns } from "./ThreeNav.vue?vue&type=template&id=07490b9d&scoped=true"
import script from "./ThreeNav.vue?vue&type=script&lang=js"
export * from "./ThreeNav.vue?vue&type=script&lang=js"
import style0 from "./ThreeNav.vue?vue&type=style&index=0&id=07490b9d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_85618a750ecf9a6cb90ae78d3f60d7c3/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07490b9d",
  null
  
)

export default component.exports